import { space } from './space';

// Chakra defaults (v1) -- https://github.com/chakra-ui/chakra-ui/blob/v1/packages/theme/src/foundations/sizes.ts
const largeSizes = {
    max: 'max-content',
    min: 'min-content',
    full: '100%',
    '3xs': '14rem',
    '2xs': '16rem',
    xs: '20rem',
    sm: '24rem',
    md: '28rem',
    lg: '32rem',
    xl: '36rem',
    '2xl': '42rem',
    '3xl': '48rem',
    '4xl': '56rem',
    '5xl': '64rem',
    '6xl': '72rem',
    '7xl': '80rem',
    '8xl': '90rem',
    '1/2': '50%',
    '2/5': '40%',
    '11/20': '55%',
};

const container = {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1200px',
    xxl: '1440px',
    xxxl: '1920px',
};

export const sizes = {
    container,
    ...largeSizes,
    ...space,
};
